var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.show,"multi-line":true,"timeout":0,"bottom":"","left":"","color":"info"}},[_vm._v("\n  A new version of LTPS is available. Reload to update.\n  "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.reload}},[_vm._v("\n    Reload\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }